module.exports = __webpack_public_path__ + "static/media/walk_disabled_person_map.593de74e.svg";